import { type RuntimeEnvironment } from './runtimeConfig';

declare const __FIELD_OPS_HOSTNAME__: string | undefined;
declare const __CORE_HOSTNAME__: string | undefined;

export const readBuildTimeRuntimeEnv = (): RuntimeEnvironment => {
  return {
    FIELD_OPS_HOSTNAME: typeof __FIELD_OPS_HOSTNAME__ === 'string' ? __FIELD_OPS_HOSTNAME__ : undefined,
    CORE_HOSTNAME: typeof __CORE_HOSTNAME__ === 'string' ? __CORE_HOSTNAME__ : undefined,
  };
};
